import React from "react";
import ReactDOM from "react-dom";
// import { createHashHistory } from "history";
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";
import './index.css';
import reportWebVitals from './reportWebVitals';
import Login from "./components/Login";
import Signup from "./components/Signup";
import ForgetPwd from "./components/ForgetPwd"
import Dashboard from "./components/Dashboard";
import VerifyOtp from "./components/VerifyOtp";
import ResetPwd from "./components/ResetPwd";
import MyProfile from "./components/MyProfile";
import Qrcode from "./components/Qrcode";
import 'bootstrap/dist/css/bootstrap.min.css';
import HelpSupport from "./components/HelpSupport";
import GenerateReport from "./components/GenerateReport"
import CustomGenerateReport from './components/CustomGenerateReport'
import MonthlyGenerateReport from './components/MonthlyGenerateReport'
// var hist = createHashHistory();

ReactDOM.render(
  <HashRouter>
    <Switch>
      {/* Public routes */}
      <Route exact path="/" component={Login} />
      <Route exact path="/signup" component={Signup} />
      <Route exact path="/forget-pwd" component={ForgetPwd} />
      <Route exact path="/verify-otp" component={VerifyOtp} />
      <Route exact path="/reset-pwd" component={ResetPwd} />

      {/* Protected routes */}
      <Route exact path="/custom-generate-report" render={() => {
        if (!localStorage.getItem('userId')) return (<Redirect to="/" />)
        else return (<CustomGenerateReport />)
      }} />
         <Route exact path="/monthly-generate-report" render={() => {
        if (!localStorage.getItem('userId')) return (<Redirect to="/" />)
        else return (<MonthlyGenerateReport />)
      }} />
      <Route exact path="/dashboard" render={() => {
        if (!localStorage.getItem('userId')) return (<Redirect to="/" />)
        else return (<Dashboard />)
      }} />
      <Route exact path="/my-profile" render={() => {
        if (!localStorage.getItem('userId')) return (<Redirect to="/" />)
        else return (<MyProfile />)
      }} />
      <Route exact path="/qr-code" render={() => {
        if (!localStorage.getItem('userId')) return (<Redirect to="/" />)
        else return (<Qrcode />)
      }} />
      <Route exact path="/generate-report" render={() => {
        if (!localStorage.getItem('userId')) return (<Redirect to="/" />)
        else return (<GenerateReport/>)
      }} />
      <Route exact path="/help" render={() => {
        if (!localStorage.getItem('userId')) return (<Redirect to="/" />)
        else return (<HelpSupport/>)
      }} />
    </Switch>
  </HashRouter>,
  document.getElementById('root')
);

reportWebVitals();
